import {Routes} from '@angular/router';
import {MsalGuard} from "@azure/msal-angular";
import {FailedComponent} from "./failed/failed.component";
import {PageComponent} from "./page/page.component";
import {SettingsComponent} from "./page/settings/settings.component";
import {TemplatesComponent} from "./page/templates/templates.component";
import {ProjectListComponent} from "./page/project/project-list/project-list.component";
import {ProjectDetailComponent} from "./page/project/project-detail/project-detail.component";
import {LightListComponent} from "./page/light/light-list/light-list.component";
import {LightDetailComponent} from "./page/light/light-detail/light-detail.component";
import {UserListComponent} from "./page/user/user-list/user-list.component";
import {UserDetailComponent} from "./page/user/user-detail/user-detail.component";
import {CountryListComponent} from "./page/country/country-list/country-list.component";
import {CountryDetailComponent} from "./page/country/country-detail/country-detail.component";
import {DepartmentListComponent} from "./page/department/department-list/department-list.component";
import {DepartmentDetailComponent} from "./page/department/department-detail/department-detail.component";
import {RegionListComponent} from "./page/region/region-list/region-list.component";
import {RegionDetailComponent} from "./page/region/region-detail/region-detail.component";
import {OverviewComponent} from "./page/overview/overview.component";
import {ErrorsComponent} from "./errors/errors.component";
import {PageNotFoundComponent} from "./errors/page-not-found/page-not-found.component";
import {ResearchListComponent} from "./page/research/research-list/research-list.component";
import {ResearchDetailComponent} from "./page/research/research-detail/research-detail.component";

export const routes: Routes = [
    {
        path: '',
        component: PageComponent,
        data: {title: 'Home'},
        children: [
            {path: '', redirectTo: 'project', pathMatch: 'full'},
            {path: 'settings', component: SettingsComponent},
            {path: 'templates', component: TemplatesComponent},
            {path: 'project', component: ProjectListComponent},
            {path: 'project/detail/:id', component: ProjectDetailComponent},
            {path: 'research', component: ResearchListComponent},
            {path: 'research/detail/:id', component: ResearchDetailComponent},
            {path: 'light', component: LightListComponent},
            {path: 'light/detail/:id', component: LightDetailComponent},
            {path: 'user', component: UserListComponent},
            {path: 'user/detail/:id', component: UserDetailComponent},
            {path: 'country', component: CountryListComponent},
            {path: 'country/detail/:id', component: CountryDetailComponent},
            {path: 'department', component: DepartmentListComponent},
            {path: 'department/detail/:id', component: DepartmentDetailComponent},
            {path: 'region', component: RegionListComponent},
            {path: 'region/detail/:id', component: RegionDetailComponent},
            {path: 'overview', component: OverviewComponent},
        ],
        canActivate: [MsalGuard]
    },
    {
        path: 'login-failed',
        component: FailedComponent
    },
    {
        path: 'error',
        component: ErrorsComponent,
        children: [
            {path: '**', component: PageNotFoundComponent},
        ]
    },
    {
        path: '**',
        component: ErrorsComponent,
        children: [
            {path: '**', component: PageNotFoundComponent},
        ]
    }
];
